// extracted by mini-css-extract-plugin
module.exports = {"modal":"GalleryContactModal_modal__hnbDg","submit":"GalleryContactModal_submit__zmUwA"};